export function computeMonthlyRevenue(props: { total_monthly_revenue?: number | string | null }[]): number {
  return props.reduce((sum, property) => sum + (Number(property.total_monthly_revenue) || 0), 0);
}
